import React from 'react';
import Icon from '../../../components/AppIcon';

const EarningOpportunityCard = ({ opportunity }) => {
  const getCategoryColor = (category) => {
    const colors = {
      account_setup: 'var(--color-primary)',
      financial_habits: 'var(--color-success)',
      engagement: 'var(--color-accent)',
      subscription: 'var(--color-warning)',
      referral: 'var(--color-secondary)'
    };
    return colors?.[category] || 'var(--color-muted-foreground)';
  };

  const getCategoryLabel = (category) => {
    const labels = {
      account_setup: 'Account Setup',
      financial_habits: 'Financial Habits',
      engagement: 'Engagement',
      subscription: 'Subscription',
      referral: 'Referral'
    };
    return labels?.[category] || category;
  };

  return (
    <div className="bg-card rounded-lg p-20 shadow-elevation-2 hover:shadow-elevation-3 transition-smooth">
      <div className="flex items-start justify-between mb-16">
        <div 
          className="flex items-center justify-center w-12 h-12 rounded-lg"
          style={{ backgroundColor: `${getCategoryColor(opportunity?.category)}15` }}
        >
          <Icon 
            name={opportunity?.icon} 
            size={24} 
            color={getCategoryColor(opportunity?.category)} 
            strokeWidth={2.5} 
          />
        </div>
        {opportunity?.completed && (
          <span className="inline-flex items-center gap-4 px-8 py-4 bg-success/10 text-success rounded text-xs font-medium">
            <Icon name="Check" size={12} />
            Completed
          </span>
        )}
      </div>

      <h3 className="text-lg font-heading font-semibold text-card-foreground mb-8">
        {opportunity?.title}
      </h3>

      <p className="text-sm text-muted-foreground mb-16">
        {opportunity?.description}
      </p>

      <div className="flex items-center justify-between pt-16 border-t border-border">
        <span 
          className="text-xs font-medium uppercase tracking-wide"
          style={{ color: getCategoryColor(opportunity?.category) }}
        >
          {getCategoryLabel(opportunity?.category)}
        </span>
        <div className="flex items-center gap-6">
          <Icon name="Coins" size={16} color="var(--color-primary)" />
          <span className="text-lg font-heading font-bold text-primary">
            +{opportunity?.points?.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EarningOpportunityCard;